import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import * as React from 'react';

export interface ZusatztoolsZertifizierungTestierungProps {
    data: any;
}

export class ZusatztoolsZertifizierungTestierung extends React.Component<ZusatztoolsZertifizierungTestierungProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ margin: 10 }}>
                {renderText('Alternatives System - Testierung', this.props.data)}
            </div>
        );
    }
}
